//= Functions & Modules
// Own
import { Client } from './Client';

export function setGlobalClient(client: Client) {
    window.g_client = client;
}
